// extracted by mini-css-extract-plugin
export default {"event-content":"FeedCardEvent_event-content__cezfq","headline":"FeedCardEvent_headline__GMGyZ"};